import { render, staticRenderFns } from "./ProdutoUnico.vue?vue&type=template&id=1a3d8dc9&"
import script from "./ProdutoUnico.vue?vue&type=script&lang=js&"
export * from "./ProdutoUnico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports